import { h } from 'preact';
import React from 'react';

import * as components from '../../Components/noticeComponents';

const Children = (props) => {
  return props.components.map((component, index) => {
    const CustomComponent = components[component.type];
    const path = [...props.path];
    path.push(index);

    return (
      <CustomComponent
        path={path}
        dev={props.dev}
        key={'n-' + path}
        component={component}
        siteId={props.siteId}
        message={props.message}
        makeChoice={props.makeChoice}
        width={props.width}
        events={props.events}
        preview={props.preview}
      />
    );
  });
}

export default Children;